module.exports = __webpack_public_path__ + "static/volvo-v70-ad955e8cd3cb068beb8ca962ff6af132.png";